export default __webpack_public_path__ + "locales/en/ResetApplicationDialog.json?hash=0bee45d434aef70dde030782e72249b3";